import React from "react";
import { KeyRound } from "lucide-react";
import MetaBridgePage from "./MetaBridgePage";

export default function ServicePsc() {
  return (
    <MetaBridgePage
      title="Pro Santé Connect (e-CPS) : intégration logiciel · MetaConnect"
      metaDescription="Intégrez Pro Santé Connect à votre logiciel : authentification e-CPS et carte CPS/CPx, OpenID Connect, données RPPS de l'annuaire santé. Pour les éditeurs."
      canonical="/services/psc"
      eyebrow="Pro Santé Connect"
      h1="Authentification forte des professionnels avec Pro Santé Connect."
      intro="MetaBridge PSC permet à votre logiciel métier d'authentifier les professionnels de santé via Pro Santé Connect (e-CPS sur smartphone ou carte CPS/CPx) — conforme aux exigences ANS et Ségur."
      icon={<KeyRound size={26} />}
      testIdSlug="psc"
      bullets={[
        "Connexion en un clic depuis votre logiciel via e-CPS ou CPS/CPx",
        "Récupération automatique du RPPS / ADELI et de la profession",
        "Conforme OpenID Connect — intégration rapide via OAuth 2.0",
        "Suppression des mots de passe métier au profit du fédéré",
        "Audit trail conforme PGSSI-S",
        "Pré-requis Ségur du Numérique en Santé",
      ]}
      details={[
        { title: "Protocoles", desc: "OpenID Connect 1.0, OAuth 2.0, JWT signés ES256." },
        { title: "Fournisseurs", desc: "GIE SESAM-Vitale (ANS) · CPS3 · CPx · e-CPS mobile." },
        { title: "Données", desc: "RPPS, profession, civilité, structure de rattachement (annuaire santé)." },
      ]}
      useCases={[
        { tag: "Éditeur", title: "Logiciel métier", desc: "Remplacement de l'authentification login/mot de passe par Pro Santé Connect." },
        { tag: "Hôpital", title: "Portail SIH", desc: "SSO Pro Santé Connect sur l'ensemble des applications du portail." },
        { tag: "Portail", title: "Patient + Pro", desc: "Un même portail expose les workflows pros (PSC) et patients (FranceConnect)." },
        { tag: "Mobile", title: "Application mobile", desc: "Authentification e-CPS sur smartphone pour les usages nomades." },
      ]}
      faq={[
        { q: "Quelle différence entre PSC et FranceConnect ?", a: "FranceConnect authentifie les citoyens. Pro Santé Connect authentifie spécifiquement les professionnels de santé via l'annuaire santé national." },
        { q: "Faut-il une certification particulière ?", a: "Le fournisseur de services (votre logiciel) doit être déclaré auprès de l'ANS. MetaBridge facilite cette démarche." },
        { q: "L'e-CPS fonctionne-t-elle sans la carte physique ?", a: "Oui, l'e-CPS est une version dématérialisée installable sur smartphone (iOS/Android) suite à une activation par l'ANS." },
      ]}
    />
  );
}
